/**
 * @jest-environment jsdom
 */

import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./reducers";
import thunk from "redux-thunk";
import { createLogger } from "redux-logger";

const initialState = {};
const middleware = [thunk];

// debug redux - Use to show all interaction of the reducers on the console.
const debug = false;

if (debug) {
    const logger = createLogger({
        predicate: false,
        collapsed: true,
        duration: true,
    });
    middleware.push(logger);
}

let composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middleware)),
);

export default store;



// WEBPACK FOOTER //
// ./src/store.js